<template>
    <div>
        <v-row v-for="i in items" :key="i" class="align-center no-gutters">
            <v-col>
                <v-skeleton-loader type="list-item" height="48" />
            </v-col>
            <v-col cols="auto">
                <v-skeleton-loader type="button" height="24" width="24" class="mr-3" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'SkeletonLoaderTree',
    props: {
        items: {
            type: Number,
            'default': 3
        }
    }
};
</script>
